<app-header [hideBackButton]="true"></app-header>

<div class="whatsapp-broadcast-container">
  <!-- Left Sidebar - Navigation -->
  <aside class="sidebar-left">
    <h2 class="sidebar-title">Campaign Tools</h2>
    <div class="sidebar-separator"></div>
    <nav class="sidebar-nav">
      <a
        class="nav-link"
        [class.active]="activeTab === 'create'"
        (click)="onTabChange('create')"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tab-icon">
          <path d="M12 5v14M5 12h14"/>
        </svg>
        <span>Create</span>
      </a>
      <a
        class="nav-link"
        [class.active]="activeTab === 'templates'"
        (click)="onTabChange('templates')"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tab-icon">
          <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
          <line x1="9" y1="9" x2="15" y2="9"/>
          <line x1="9" y1="13" x2="15" y2="13"/>
          <line x1="9" y1="17" x2="13" y2="17"/>
        </svg>
        <span>Templates</span>
      </a>
      <a
        class="nav-link"
        [class.active]="activeTab === 'metrics'"
        (click)="onTabChange('metrics')"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tab-icon">
          <line x1="18" y1="20" x2="18" y2="10"/>
          <line x1="12" y1="20" x2="12" y2="4"/>
          <line x1="6" y1="20" x2="6" y2="14"/>
        </svg>
        <span>Metrics</span>
      </a>
      <a
        class="nav-link"
        [class.active]="activeTab === 'messages'"
        (click)="onTabChange('messages')"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="tab-icon">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
        <span>Messages</span>
      </a>
    </nav>
  </aside>

  <!-- Main Content -->
  @if (activeTab === 'create') {
    <main class="main-content">
      <div class="content-header content-header-inline">
        <button type="button" class="back-icon-btn" (click)="goBack()" title="Back to Home">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
        </button>
        <h1 class="page-title">WhatsApp Campaign</h1>
      </div>
      <!-- Scrollable Form Content -->
      <div class="form-scrollable">
        <!-- Error/Success Messages -->
        @if (errorMessage) {
          <div class="alert alert-error">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
            </svg>
            <span>{{ errorMessage }}</span>
            <button class="alert-close" (click)="errorMessage = ''">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
          </div>
        }
        @if (successMessage) {
          <div class="alert alert-success">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
            </svg>
            <span>{{ successMessage }}</span>
            <button class="alert-close" (click)="successMessage = ''">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
            </button>
          </div>
        }
        <!-- Two Column Layout -->
        <form [formGroup]="campaignForm" (ngSubmit)="triggerCampaign()" id="campaignForm">
          <div class="form-two-columns">
            <!-- Left Column: Campaign Name, Image, User List -->
            <div class="form-left-column">
              <!-- Campaign Name -->
              <div class="form-group">
                <label for="campaignName">Campaign Name *</label>
                <input
                  id="campaignName"
                  type="text"
                  formControlName="campaignName"
                  placeholder="Enter campaign name"
                  class="form-input"
                  [class.error]="campaignName?.invalid && campaignName?.touched"
                  />
                  @if (campaignName?.invalid && campaignName?.touched) {
                    <small class="error-text">Campaign name is required (min 3 characters)</small>
                  }
                </div>
                <!-- Image Upload -->
                <div
                  class="image-upload"
                  (dragover)="onDragOver($event)"
                  (drop)="onDrop($event)"
                  [class.has-image]="uploadedImage"
                  >
                  @if (uploadedImage) {
                    <div class="uploaded-image-container">
                      <img [src]="uploadedImage" alt="Uploaded image" class="uploaded-image" />
                      <button type="button" class="remove-image-btn" (click)="removeImage()" title="Remove image">
                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                        </svg>
                      </button>
                    </div>
                  } @else {
                    <div class="upload-placeholder">
                      <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"/>
                      </svg>
                      <p>Click to upload header image or drag and drop</p>
                      <input type="file" (change)="onFileSelected($event)" accept=".jpg,.jpeg,.png" class="file-input" />
                    </div>
                  }
                </div>
                <!-- User List Excel Upload -->
                <div class="form-group">
                  <label for="userListExcel">User List (Excel) *</label>
                  <div class="file-upload-container" [class.has-file]="uploadedUserList">
                    @if (uploadedUserList) {
                      <div class="file-info">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                        </svg>
                        <span>{{ uploadedUserList.name }}</span>
                        <button type="button" class="remove-file-btn" (click)="removeUserList()" title="Remove file">
                          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                          </svg>
                        </button>
                      </div>
                    } @else {
                      <div class="upload-prompt">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                        </svg>
                        <span>Upload Excel file (.xlsx or .xls)</span>
                        <input type="file" id="userListExcel" (change)="onUserListFileSelected($event)" accept=".xlsx,.xls" class="file-input" />
                      </div>
                    }
                  </div>
                  <small class="help-text">Upload the Excel file containing user list for the campaign</small>
                </div>
              </div>
              <!-- Right Column: Text Content -->
              <div class="form-right-column">
                <!-- Variable Fields (P1, P2, P3) -->
                <div class="variables-section">
                  @for (field of variableFields; track field.id) {
                    <div class="form-group">
                      <label [for]="'variable-' + field.id">{{ field.label }}</label>
                      <input
                        [id]="'variable-' + field.id"
                        type="text"
                        [value]="field.value"
                        (input)="onVariableChange(field.id, $any($event.target).value)"
                        [placeholder]="'Enter value for ' + field.label"
                        class="form-input"
                        />
                        @if (variableFields.length > 1) {
                          <button type="button" class="remove-field-btn" (click)="removeVariableField(field.id)" title="Remove field">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                            </svg>
                          </button>
                        }
                      </div>
                    }
                    @if (variableFields.length < 3) {
                      <button type="button" class="add-field-btn" (click)="addVariableField()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                          <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                        </svg>
                        Add paragraph
                      </button>
                    }
                  </div>
                </div>
              </div>
            </form>
          </div>
          <!-- Sticky Footer Actions -->
          <div class="form-actions-sticky">
            <button type="button" class="btn btn-outline" (click)="resetForm()" [disabled]="isLoading || !hasFormContent()" title="Clear all fields">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
              </svg>
              Clear
            </button>
            <button type="button" class="btn btn-secondary" (click)="saveCampaign()" [disabled]="isLoading">
              @if (isLoading) { Saving... } @else { Save }
              </button>
              <button type="submit" class="btn btn-primary" [disabled]="isLoading" form="campaignForm">
                @if (isLoading) {
                  <span class="loading-spinner"></span>
                  Processing...
                } @else {
                  Create Campaign
                }
              </button>
            </div>
          </main>
        }

        @if (activeTab === 'templates') {
          <main class="main-content">
            <div class="content-header">
              <h1 class="page-title">Templates</h1>
            </div>
            <div class="templates-container">
              <!-- Error Message -->
              @if (templatesError) {
                <div class="alert alert-error">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                  </svg>
                  <span>{{ templatesError }}</span>
                </div>
              }
              <!-- Loading State -->
              @if (templatesLoading) {
                <div class="loading-state">
                  <div class="loading-spinner-large"></div>
                  <p>Loading templates...</p>
                </div>
              }
              <!-- Templates List -->
              @if (!templatesLoading && usedTemplates.length > 0) {
                <div class="templates-grid">
                  @for (template of usedTemplates; track template._id) {
                    <div class="whatsapp-template-card">
                      <!-- WhatsApp-style Header -->
                      <div class="whatsapp-template-header">
                        <div class="template-header-info">
                          <div class="template-name">{{ template.templateName }}</div>
                          <div class="template-meta">{{ template.createdAt | date:'short' }} • By {{ template.createdByName }}</div>
                        </div>
                        <div class="template-actions-top">
                          <button type="button" class="btn-use-template btn-use" (click)="useTemplate(template)">
                            Use
                          </button>
                          <button type="button" class="btn-use-template btn-delete" (click)="deleteTemplate(template._id)">
                            Delete
                          </button>
                        </div>
                      </div>
                      <!-- WhatsApp-style Messages Area -->
                      <div class="whatsapp-template-messages">
                        <!-- Date Divider -->
                        <div class="whatsapp-date-divider">
                          <span>Template Preview</span>
                        </div>
                        <!-- Combined Message with Image and Text -->
                        <div class="whatsapp-message-bubble message-received">
                          <!-- Header Media (if present) -->
                          @if (template.headerMediaUrl && template.headerType !== 'none') {
                            <div class="message-media-container">
                              @if (template.headerType === 'image') {
                                <img [src]="template.headerMediaUrl" alt="Media" class="message-media-image" />
                              } @else if (template.headerType === 'video') {
                                <video [src]="template.headerMediaUrl" class="message-media-video" controls></video>
                              }
                            </div>
                          }
                          <!-- Fixed Greeting + Message Paragraphs + Fixed Closing -->
                          @if (getTemplateCompleteMessage(template)) {
                            <div class="message-text">{{ getTemplateCompleteMessage(template) }}</div>
                          }
                          <div class="message-time">12:30 PM</div>
                        </div>
                        <!-- Fixed Action Buttons -->
                        <div class="whatsapp-message-bubble message-received">
                          <div class="message-button">📅 Book A Demo</div>
                        </div>
                        <div class="whatsapp-message-bubble message-received">
                          <div class="message-button">✉️ Quick Enquiry (Email)</div>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
              <!-- Empty State -->
              @if (!templatesLoading && usedTemplates.length === 0 && !templatesError) {
                <div class="empty-state">
                  <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="currentColor" class="empty-icon">
                    <path d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"/>
                  </svg>
                  <h3 class="empty-title">No templates found</h3>
                  <p class="empty-description">Create a campaign to see it appear here as a template</p>
                </div>
              }
            </div>
          </main>
        }

        @if (activeTab === 'metrics') {
          <main class="main-content">
            <!-- Campaign List View -->
            @if (!selectedCampaign) {
              <div class="content-header">
                <h1 class="page-title">Campaign Metrics</h1>
              </div>
              <!-- Coming Soon Banner -->
              <div class="coming-soon-banner">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
                </svg>
                <span>Coming Soon: Advanced analytics dashboard will be available once backend API is ready</span>
              </div>
              <div class="metrics-container">
                <!-- Error Message -->
                @if (metricsError) {
                  <div class="alert alert-error">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                    <span>{{ metricsError }}</span>
                  </div>
                }
                <!-- Loading State -->
                @if (metricsLoading) {
                  <div class="loading-state">
                    <div class="loading-spinner-large"></div>
                    <p>Loading metrics...</p>
                  </div>
                }
                <!-- Metrics List -->
                @if (campaigns.length > 0) {
                  <div class="campaigns-list-wrapper">
                    <div class="campaigns-list-container" (scroll)="onScroll($event)">
                      <div class="campaigns-list">
                        @for (campaign of campaigns; track campaign._id) {
                          <div class="campaign-card campaign-card-clickable" (click)="viewCampaignUsers(campaign)">
                            <div class="campaign-header">
                              <div class="campaign-info">
                                <h3 class="campaign-name">{{ campaign.campaignName }}</h3>
                                <p class="campaign-meta">Created: {{ campaign.createdAt | date:'short' }} • Status: {{ campaign.status }}</p>
                              </div>
                              <div class="campaign-stats">
                                <div class="stat-item">
                                  <span class="stat-label">Total Users</span>
                                  <span class="stat-value">{{ campaign.totalUsers || 0 }}</span>
                                </div>
                                <div class="stat-item">
                                  <span class="stat-label">Sent</span>
                                  <span class="stat-value">{{ campaign.sentCount || 0 }}</span>
                                </div>
                                <div class="stat-item">
                                  <span class="stat-label">Delivered</span>
                                  <span class="stat-value stat-success">{{ campaign.deliveredCount || 0 }}</span>
                                </div>
                                <div class="stat-item">
                                  <span class="stat-label">Failed</span>
                                  <span class="stat-value stat-error">{{ campaign.failedCount || 0 }}</span>
                                </div>
                                <div class="stat-item">
                                  <span class="stat-label">Seen</span>
                                  <span class="stat-value">{{ campaign.seenCount || 0 }}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                    <!-- Loading More Indicator -->
                    @if (isLoadingMore) {
                      <div class="loading-more">
                        <div class="loading-spinner-small"></div>
                        <span>Loading more campaigns...</span>
                      </div>
                    }
                  </div>
                }
              </div>
            }
            <!-- Campaign Users Detail View -->
            @if (selectedCampaign) {
              <div class="content-header content-header-with-back">
                <button class="back-button" (click)="backToCampaigns()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                  </svg>
                  Back to Campaigns
                </button>
                <h1 class="page-title">{{ selectedCampaign.campaignName }} - Users</h1>
              </div>
              <div class="metrics-container">
                <!-- Error Message -->
                @if (campaignUsersError) {
                  <div class="alert alert-error">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                    <span>{{ campaignUsersError }}</span>
                  </div>
                }
                <!-- Loading State -->
                @if (campaignUsersLoading) {
                  <div class="loading-state">
                    <div class="loading-spinner-large"></div>
                    <p>Loading campaign users...</p>
                  </div>
                }
                <!-- Campaign Users List -->
                @if (!campaignUsersLoading && campaignUsers.length > 0) {
                  <div class="campaign-users-list-container">
                    <div class="campaign-users-list">
                      @for (user of campaignUsers; track user._id) {
                        <div class="user-card">
                          <div class="user-card-main">
                            <div class="user-info">
                              <div class="user-name">{{ user.name || 'N/A' }}</div>
                              <div class="user-phone">{{ user.phoneNumber || 'N/A' }}</div>
                            </div>
                            <div class="user-status">
                              <span class="status-badge" [class.status-success]="user.status === 'DELIVERED' || user.status === 'SENT'" [class.status-error]="user.status === 'FAILED'" [class.status-pending]="user.status === 'PENDING'">
                                {{ user.status || 'Unknown' }}
                              </span>
                            </div>
                            <div class="user-timestamp">
                              <div class="timestamp">Created: {{ user.createdAt | date:'short' }}</div>
                              <div class="timestamp">Updated: {{ user.updatedAt | date:'short' }}</div>
                            </div>
                          </div>
                          @if (user.errorMessage) {
                            <div class="error-message">{{ user.errorMessage }}</div>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- Empty State -->
                @if (!campaignUsersLoading && campaignUsers.length === 0 && !campaignUsersError) {
                  <div class="empty-state">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="currentColor" class="empty-icon">
                      <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
                    </svg>
                    <h3 class="empty-title">No users found</h3>
                    <p class="empty-description">This campaign has no users yet</p>
                  </div>
                }
              </div>
            }
          </main>
        }

        @if (activeTab === 'messages') {
          <main class="main-content">
            <!-- Messages List View -->
            @if (!selectedConversation) {
              <div class="content-header content-header-with-filter">
                <h1 class="page-title">Incoming Messages</h1>
                <div class="messages-date-filter">
                  <mat-form-field
                    class="messages-date-range-field"
                    style="
                      --mat-form-field-filled-with-label-container-padding-bottom: 0px;
                      --mat-form-field-container-height: 0px;
                      --mat-form-field-filled-with-label-container-padding-top: 0px;
                      --mdc-filled-text-field-container-color: #fff;
                      --mat-form-field-container-vertical-padding: 10px;
                    "
                  >
                    <mat-date-range-input [rangePicker]="messagesRangePicker" [max]="today">
                      <input
                        matStartDate
                        placeholder="Start date"
                        [(ngModel)]="messagesStartDate"
                        [max]="today"
                        />
                      <input
                        matEndDate
                        placeholder="End date"
                        [(ngModel)]="messagesEndDate"
                        [max]="today"
                        />
                    </mat-date-range-input>
                    <mat-datepicker-toggle
                      matIconSuffix
                      [for]="messagesRangePicker"
                    ></mat-datepicker-toggle>
                    <mat-date-range-picker #messagesRangePicker>
                      <mat-date-range-picker-actions>
                        <button
                          mat-button
                          matDateRangePickerCancel
                          (click)="clearMessagesDateFilter()"
                          >
                          Reset
                        </button>
                        <button
                          mat-raised-button
                          color="primary"
                          matDateRangePickerApply
                          (click)="applyMessagesDateFilter()"
                          >
                          Apply
                        </button>
                      </mat-date-range-picker-actions>
                    </mat-date-range-picker>
                  </mat-form-field>
                </div>
              </div>
              <div class="messages-container">
                <!-- Error Message -->
                @if (messagesError) {
                  <div class="alert alert-error">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                    <span>{{ messagesError }}</span>
                  </div>
                }
                <!-- Loading State -->
                @if (messagesLoading && messages.length === 0) {
                  <div class="loading-state">
                    <div class="loading-spinner-large"></div>
                    <p>Loading messages...</p>
                  </div>
                }
                <!-- Messages Table -->
                @if (messages.length > 0) {
                  <div class="messages-table-wrapper">
                    <div class="messages-table-container" (scroll)="onMessagesScroll($event)">
                      <table class="messages-table">
                        <thead>
                          <tr>
                            <th>Phone Number</th>
                            <th>Name</th>
                            <th>Total Messages</th>
                            <th>Last Message</th>
                            <th>Created At</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (message of messages; track message.phoneNumberId || message.phoneNumber) {
                            <tr class="message-row message-row-clickable" (click)="viewConversation(message)">
                              <td class="message-cell message-phone">
                                <div class="phone-container">
                                  <span class="phone-number-text">{{ message.phoneNumber || 'N/A' }}</span>
                                  <button
                                    type="button"
                                    class="copy-phone-btn"
                                    (click)="copyPhoneNumber(message.phoneNumber, $event)"
                                    title="Copy phone number"
                                    >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor">
                                      <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
                                    </svg>
                                  </button>
                                </div>
                              </td>
                              <td class="message-cell message-name">{{ message.fromName || 'N/A' }}</td>
                              <td class="message-cell message-count">{{ message.totalMessages || 0 }}</td>
                              <td class="message-cell message-last">
                                @if (message.lastMessage?.messageBody) {
                                  <span class="message-body">{{ message.lastMessage.messageBody }}</span>
                                  @if (message.lastMessage.messageType && message.lastMessage.messageType !== 'text') {
                                    <span class="message-type-badge" [class]="'badge-' + message.lastMessage.messageType">{{ message.lastMessage.messageType }}</span>
                                  }
                                } @else {
                                  N/A
                                }
                              </td>
                              <td class="message-cell message-date">{{ message.lastMessage?.createdAt | date:'short' : 'N/A' }}</td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    </div>
                    @if (messagesLoading && messages.length > 0) {
                      <div class="loading-more">
                        <div class="loading-spinner-small"></div>
                        <span>Loading more messages...</span>
                      </div>
                    }
                  </div>
                }
                <!-- Empty State -->
                @if (!messagesLoading && messages.length === 0 && !messagesError) {
                  <div class="empty-state">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="currentColor" class="empty-icon">
                      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
                    </svg>
                    <h3 class="empty-title">No messages found</h3>
                    <p class="empty-description">No incoming WhatsApp messages yet</p>
                  </div>
                }
              </div>
            }
            <!-- Conversation Detail View -->
            @if (selectedConversation) {
              <div class="content-header content-header-inline">
                <button type="button" class="back-icon-btn" (click)="backToMessages()" title="Back to Messages">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                  </svg>
                </button>
                <h1 class="page-title">
                  {{ selectedConversation.fromName || 'Unknown' }}
                  <span class="page-subtitle">{{ selectedConversation.phoneNumber }}</span>
                </h1>
              </div>
              <div class="conversation-container">
                <!-- Error Message -->
                @if (conversationError) {
                  <div class="alert alert-error">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                    </svg>
                    <span>{{ conversationError }}</span>
                  </div>
                }
                <!-- Loading State -->
                @if (conversationLoading && conversationMessages.length === 0) {
                  <div class="loading-state">
                    <div class="loading-spinner-large"></div>
                    <p>Loading conversation...</p>
                  </div>
                }
                <!-- Conversation Messages -->
                @if (!conversationLoading && conversationMessages.length > 0) {
                  <div class="conversation-messages-container">
                    <div class="conversation-messages conversation-messages-chat">
                      @for (msg of conversationMessages; track trackByMessageId($index, msg)) {
                        <div class="chat-row" [class.chat-row-incoming]="getDirectionClass(msg.direction) === 'incoming'" [class.chat-row-outgoing]="getDirectionClass(msg.direction) !== 'incoming'">
                          <div class="chat-bubble" [class]="'bubble-' + getDirectionClass(msg.direction)">
                            <!-- Bubble Meta -->
                            <div class="chat-bubble-meta">
                              <span class="chat-sender" [class]="'sender-' + getDirectionClass(msg.direction)">{{ getSenderLabel(msg) }}</span>
                              @if (msg.messageType && msg.messageType !== 'text') {
                                <span class="chat-type-tag">{{ msg.messageType }}</span>
                              }
                            </div>
                            <!-- Message Content -->
                            @if (msg.messageType === 'text' && msg.messageBody) {
                              <div class="chat-text">{{ msg.messageBody }}</div>
                            } @else if (msg.messageType === 'image' && msg.fileUrl) {
                              <div class="chat-media">
                                <img [src]="msg.fileUrl" alt="Image message" class="chat-media-image" />
                                @if (msg.messageBody) {
                                  <div class="chat-caption">{{ msg.messageBody }}</div>
                                }
                              </div>
                            } @else if (msg.messageType === 'video' && msg.fileUrl) {
                              <div class="chat-media">
                                <video [src]="msg.fileUrl" controls class="chat-media-video"></video>
                                @if (msg.messageBody) {
                                  <div class="chat-caption">{{ msg.messageBody }}</div>
                                }
                              </div>
                            } @else if (msg.messageType === 'document' && msg.fileUrl) {
                              <div class="chat-document">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                                  <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
                                </svg>
                                <a [href]="msg.fileUrl" target="_blank" rel="noopener noreferrer" class="chat-document-link">
                                  {{ msg.messageBody || 'View Document' }}
                                </a>
                              </div>
                            } @else {
                              <div class="chat-text chat-text-unknown">
                                {{ getMessageDisplayText(msg) }}
                              </div>
                            }
                            <div class="chat-bubble-time">{{ msg.createdAt | date:'MMM d, h:mm a' }}</div>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
                }
                <!-- Empty State -->
                @if (!conversationLoading && conversationMessages.length === 0 && !conversationError) {
                  <div class="empty-state">
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="currentColor" class="empty-icon">
                      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"/>
                    </svg>
                    <h3 class="empty-title">No conversation found</h3>
                    <p class="empty-description">No messages from this contact yet</p>
                  </div>
                }
              </div>
            }
          </main>
        }

        <!-- Right Sidebar - WhatsApp Preview -->
        @if (activeTab === 'create') {
          <aside class="sidebar-right">
            <h2 class="sidebar-title">Preview</h2>
            <div class="whatsapp-preview">
              <!-- WhatsApp Header -->
              <div class="whatsapp-header">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"/>
                </svg>
                <div class="header-info">
                  <div class="header-contact">Ink In Caps</div>
                  <div class="header-status">Business Account</div>
                </div>
                <div class="header-actions disabled-action">
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"/>
                  </svg>
                </div>
              </div>

              <!-- WhatsApp Messages Area -->
              <div class="whatsapp-messages">
                <!-- Date Divider -->
                <div class="whatsapp-date-divider">
                  <span>Today</span>
                </div>

                @if (previewData.image) {
                  <div class="whatsapp-message-bubble message-received">
                    <div class="message-image-container">
                      <img [src]="previewData.image" alt="Media" class="message-image" />
                    </div>
                    <div class="message-time">12:30 PM</div>
                  </div>
                }

                <!-- Main template message -->
                @if (completeMessage) {
                  <div class="whatsapp-message-bubble message-received">
                    <div class="message-text">{{ completeMessage }}</div>
                    <div class="message-time">12:30 PM</div>
                  </div>
                }

                <!-- WhatsApp Action Buttons in Preview -->
                @if (actionButtons.length > 0) {
                  @for (button of actionButtons; track button.id) {
                    <div class="whatsapp-message-bubble message-received">
                      <div class="message-button disabled-button">{{ button.text }}</div>
                    </div>
                  }
                }

                @if (!completeMessage && !previewData.image && actionButtons.length === 0) {
                  <div class="whatsapp-message-bubble message-received">
                    <div class="message-text message-placeholder">Your message will appear here...</div>
                    <div class="message-time">12:30 PM</div>
                  </div>
                }
              </div>

              <!-- WhatsApp Input Area (Visual Only) -->
              <div class="whatsapp-input-area">
                <div class="input-icons disabled-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"/>
                  </svg>
                </div>
                <div class="input-field">
                  <span>Message</span>
                </div>
                <div class="input-actions disabled-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/>
                  </svg>
                </div>
              </div>
            </div>
          </aside>
        }
      </div>

      <!-- Delete Confirmation Modal -->
      @if (showDeleteModal && templateToDelete) {
        <div class="modal-overlay" (click)="closeDeleteModal()">
          <div class="modal-container" (click)="$event.stopPropagation()">
            <div class="modal-header">
              <div class="modal-icon warning">
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
                </svg>
              </div>
              <h2 class="modal-title">Delete Template</h2>
              <button type="button" class="modal-close" (click)="closeDeleteModal()" title="Close">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
                </svg>
              </button>
            </div>

            <div class="modal-body">
              <p class="modal-message">Are you sure you want to delete the template <strong>"{{ templateToDelete.templateName }}"</strong>?</p>
              <p class="modal-warning">This action cannot be undone.</p>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-outline" (click)="closeDeleteModal()" [disabled]="isDeleting">
                Cancel
              </button>
              <button type="button" class="btn btn-danger" (click)="confirmDeleteTemplate()" [disabled]="isDeleting">
                @if (isDeleting) {
                  <span class="loading-spinner-small"></span>
                  Deleting...
                } @else {
                  Delete Template
                }
              </button>
            </div>
          </div>
        </div>
      }
